import { useState } from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { errorMessage } from '../api/client';
import BrandMark from '../components/BrandMark';
import { useBranding } from '../branding/BrandingProvider';

export default function Login() {
  const { login, isAuthenticated, loading } = useAuth();
  const { name: crmName } = useBranding();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('admin@example.com');
  const [password, setPassword] = useState('password');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  if (!loading && isAuthenticated) {
    const dest = location.state?.from?.pathname || '/';
    return <Navigate to={dest} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await login(email, password);
      navigate(location.state?.from?.pathname || '/', { replace: true });
    } catch (err) {
      setError(errorMessage(err, 'Login failed.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth">
      <div className="auth-art">
        <div className="brand" style={{ padding: 0 }}>
          <BrandMark style={{ background: 'rgba(255,255,255,0.2)', boxShadow: 'none' }} />
          <span>{crmName}</span>
        </div>
        <div>
          <h1>Run everything from one place.</h1>
          <p>Manage admins, roles and granular permissions with a fast, secure control panel.</p>
        </div>
        <div style={{ fontSize: 13, opacity: 0.75 }}>&copy; {new Date().getFullYear()} {crmName}</div>
      </div>

      <div className="auth-form">
        <div className="auth-box">
          <h2>Welcome back</h2>
          <p className="muted" style={{ margin: '0 0 24px' }}>
            Sign in to your admin account to continue.
          </p>
          {error && <div className="notice notice-error">{error}</div>}
          <form onSubmit={submit}>
            <div className="field">
              <label>Email</label>
              <input
                type="email"
                value={email}
                autoComplete="username"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="field">
              <label>Password</label>
              <input
                type="password"
                value={password}
                autoComplete="current-password"
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button
              className="btn btn-primary"
              style={{ width: '100%', padding: '10px 14px' }}
              disabled={busy}
            >
              {busy ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
